import axios from "axios";
import { log } from "@/plugins/consoleLogger";
import { locationsUrl } from "../moduleUrls";

const getLocationById = async (id, country_code, party_id) => {
  try {
    log("trace", "trying to get location by ID");
    const res = await axios.get(
      locationsUrl + "/locations/" + country_code + "/" + party_id + "/" + id,
      {
        timeout: 30000
      }
    );

    log("log", res);

    if (res.status === 200) {
      return res.data.data;
    } else {
      throw new Error("Unable to acess Location API");
    }
  } catch (err) {
    log("error", `Failed Backoffice call with: ${err.toString()}`);
    throw new Error("Unable to acess Location API");
  }
};

export { getLocationById };
